import { generateUUID } from "utils/appUtil";

export declare type entityId = string;

export declare enum MessageReferenceType {
  Update = "update",
  Refer = "refer",
  Remove = "remove",
}


export const  getItemListRequestPayload = (paths: any, returnPath: string = '$', pagination: IPagination = {offset: 0, limit: 200},  searchArguments: object = undefined): IPublishRequest => {  
  const payload: IListRequest = {
        paths,
        returnPaths: [returnPath],
        pagination: pagination,
        ...searchArguments
      }
     return payload
};

export const updateItemRequestPayload = (id: number, op: RequestOperation, path: string, data: any ): ICreateOrUpdateRequest=> {
  return {
    objectId: id,
    operation: op,
    path,
    value: data,
  }
}

export const wrapRequestPayload = (payload: IPublishRequest | any, id?: string): IPublishWrapRequest => {
     return {
       id: id || generateUUID(),
       data: {
         ...payload
       }
     }
};

const searchStringGenerator = (search: string)=> {
  const searchSplit = search.split(' ');
  if(searchSplit.length === 1)return `@title:(%${searchSplit[0]}%)`
  else{
    let lastWord = searchSplit.pop();
    return `@title:(${searchSplit.join('&')}&%${lastWord}%)`
  }
};

export const getPageSearchArgument = (search?: string): any => {
  let index = 'pageTitleIndex';
  let filterArg = '';
  const filter = JSON.parse(localStorage.getItem('filter'));
  let sortBy = '';
  if(filter){
    const {readStatus, pageType, pageStatus, userStatus, deleted, createdAt} = filter;
    if(readStatus.length === 1){
      if(readStatus[0] === 'Read')filterArg += `-(@unreadUsers:{${localStorage.getItem('RID')}})`;
      else filterArg += `@unreadUsers:{${localStorage.getItem('RID')}}`;
    }
    filterArg+= `@pageType:{${pageType}}`;
    if(userStatus){
      filterArg+= `@statusUser:{${userStatus}*}`;
    }
    if(pageStatus){
      filterArg+= `@pageStatus:{${pageStatus}}`;
    }
    filterArg+= `@objectStatus:{${deleted ? 'deleted': 'active'}}`;
    if(createdAt){
      let date = new Date(createdAt)
      filterArg+= `@createdAt:[${date.setHours(0,0,0,0)},+inf]@createdAt: [-inf,${date.setHours(23,59,59,999)}]`;
    }
    //if()
    sortBy = `SORTBY createdAt ${filter.order}`;
  }  
  // return `${process.env.REACT_APP_ECO_SYSTEM}:${index} ${search ? searchStringGenerator(search): ''}@pageMembers:{2345}${filterArg} ${sortBy}`;
  return {
    searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:${index}`,
    searchQuery: `${search ? searchStringGenerator(search): ''}@pageMembers:{${localStorage.getItem('RID')}}${filterArg}`,
    searchOptions: `${sortBy}`
  }
};


const getRequestHeader = (connectionId: entityId, rootUserId: entityId): any => {
  return {
    accessToken: '',
    connectionId: connectionId,
    userId: rootUserId,
    udid: generateUUID(),
  };
};

export const getMessageRequestPayload = (
  connectionId: entityId,
  rootUserId: entityId,
  pageId: entityId,
  message: any,
  refMessage: MessageReferenceType | undefined = undefined,
  originalPageMessageId: entityId | undefined = undefined,
  originalCreatedAt?: number
): any => {
  const date = new Date().getTime();
  return {
    header: {
      ...getRequestHeader(connectionId, rootUserId),
    },
    messages: [
      {
        message,
        connectionInfo: {
          connectionMessageId: generateUUID(),
          connectionId: connectionId,
          pageId: pageId,
          userId: rootUserId,
          createdAt: date,
          originalCreatedAt: originalCreatedAt || date,
          refMessage,
          originalPageMessageId,
        },
      },
    ],
    connectionId: connectionId,
    connectionPubTopic: '',
  };
};